define(["jquery"], function ($) {
    'use strict';

    const oosLink = $('.oos-link');
    oosLink.hide();

    function findAlertEl (productId) {
        return document.querySelector(".product.alert.id_" + productId);
    }

    function resetAlertState () {
        [].forEach.call(document.querySelectorAll(".product.alert"), function(
            el
        ) {
            el.classList.add("hide");
        });
        $("#product-addtocart-button").removeClass("hide");
        oosLink.hide();
    }

    return function () {
        $.widget("mage.configurable", $.mage.configurable, {
            /**
             * @param {HTMLSelectElement} el modified select elemnt
             * @private
             */
            _configureElement: function (el) {
                resetAlertState();
                this._super(el);
                const alert = findAlertEl(this._getSimpleProductId(el));

                if (alert) {
                    alert.classList.remove("hide");
                    oosLink.show();
                    if (
                        el.selectedOptions[0].getAttribute("data-out-of-stock")
                    ) {
                        $(this.element).trigger(
                            "configurable.out-of-stock-selection"
                        );
                        $("#product-addtocart-button").addClass("hide");
                    } else {
                        $(this.element).trigger(
                            "configurable.in-stock-selection"
                        );
                    }
                } else {
                    $(this.element).trigger("configurable.in-stock-selection");
                }
            },

            _fillSelect: function(el) {
                this._super(el);
                const selectedOption = el.value;
                $.each(
                    el.options,
                    function(i, option) {
                        if (option.disabled) {
                            el.value = option.value;
                            const productId = this._getSimpleProductId(el);
                            if (findAlertEl(productId)) {
                                option.disabled = false;
                                option.setAttribute("data-out-of-stock", true);
                            }
                        }
                    }.bind(this)
                );

                el.value = selectedOption;
            }
        });
    };
});
